export default __webpack_public_path__ + "static/training-support-882ffdf64c6e1c1f71db15ee90ab891b.jpg";